import { Sizes } from '../../constants'

export const MQSizes = {
    sm: Sizes.width.sm,
    md: Sizes.width.md,
    lg: Sizes.width.lg,
    xl: Sizes.width.xl,
    mobile: Sizes.width.lg,
}

/**
 * Generates a css media query
 * @param {Number|String} limit width limit in pixels
 * @param {String} css
 */
const mediaQuery = (limit, css) =>
    limit && css
        ? `@media (max-width: ${limit}px) {
        ${css}
      }`
        : ''

/**
 * Generates a css media query
 * @param {Number|String} bottomLimit width limit in pixels
 * @param {String} css
 */
export const mediaQueryForBigger = (bottomLimit, css) =>
    bottomLimit && css
        ? `@media (min-width: ${bottomLimit}px) {
      ${css}
    }`
        : ''

// Generate shortcut functions
Object.keys(MQSizes).forEach((keySize) => {
    if (!mediaQuery[keySize]) {
        mediaQuery[keySize] = (css) => mediaQuery(MQSizes[keySize], css)
    }
})

// Generate shortcut functions
Object.keys(MQSizes).forEach((keySize) => {
    if (!mediaQueryForBigger[keySize]) {
        mediaQueryForBigger[keySize] = (css) => mediaQueryForBigger(MQSizes[keySize], css)
    }
})

export default mediaQuery
